// Localização: ./src/index.js (versão 2.0.0)

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js'; // Nosso componente App principal

import './index.css'; // Deve ser um caminho relativo, sem o 'src' na frente, pois já estamos nele.

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);